<template>
    <div class="dvBgiBox">
        <div style="height: 30px;">
            <p style="font-size: 22px;font-weight: 600;text-align: right;color: #fff;">{{ $t('storage.title') }}</p>
        </div>


        <div class="bottomBox">
            <img src="../../assets/right01-6.png"
                style="width: 240px;height: 240px;position: absolute;top: -10px;left: 50%;transform: translateX(-50%);"
                alt="">
            <div
                style="position: relative;display: flex;flex-direction: row;justify-content: space-between;align-items: center;">

                <div>
                    <div class="row01">
                        <div class="item">
                            <img src="../../assets/current.png" style="width: 30px;height: 30px;" alt="">
                        </div>
                        <div class="tt">
                            <img src="../../assets/right01-5.png" class="imgLeft" alt="">
                            <div
                                style="position: absolute;top: 0;left: 10px;width: 100%;display: flex;flex-direction: column;">
                                <span
                                    style="font-size: 24px;color: #fff;font-weight: 600;">{{ energy_storage.dumpEnergy }}v</span>
                                <span style="font-size: 14px;color: #fff;">{{ $t('storage.batteryVoltage') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="row01">
                        <div class="item">
                            <img src="../../assets/ADvoltage.png" style="width: 30px;height: 30px;" alt="">
                        </div>
                        <div class="tt">
                            <img src="../../assets/right01-5.png" class="imgLeft" alt="">
                            <div
                                style="position: absolute;top: 0;left: 10px;width: 100%;display: flex;flex-direction: column;">
                                <div>
                                    <span
                                    style="font-size: 24px;color: #fff;font-weight: 600;">{{ energy_storage.batchargeCurrent }}</span>
                                    <span style="font-size: 18px;font-weight: 600;">A</span>
                                </div>
                                <span style="font-size: 14px;color: #fff;">{{ $t('storage.batteryCurrent') }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="right01-7">
                    <div style="display: flex;flex-direction: column;align-items: center;">
                        <p style="font-size: 23px;font-weight: 600;color: #fff;">{{ $t('storage.soc') }}</p>
                        <p style="font-size: 33px;font-weight: 600;color: #fff;">{{ energy_storage.soc }}</p>
                    </div>
                </div>

                <div>
                    <div class="row01">
                        <div class="tt">
                            <img src="../../assets/right01-4.png" class="imgRight" alt="">
                            <div
                                style="position: absolute;top: 0;right: 10px;width: 100%;display: flex;flex-direction: column;align-items: flex-end;">
                                <span
                                    style="font-size: 24px;color: #fff;font-weight: 600;">{{ energy_storage.dischargePower }}w</span>
                                <span style="font-size: 14px;color: #fff;">{{ $t('common.power') }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <img src="../../assets/brightnessPower.png" style="width: 38px;height: 38px;" alt="">
                        </div>
                    </div>

                    <div class="row01">
                        <div class="tt">
                            <img src="../../assets/right01-4.png" class="imgRight" alt="">
                            <div
                                style="position: absolute;top: 0;right: 10px;width: 100%;display: flex;flex-direction: column;align-items: flex-end;">
                                <span
                                    style="font-size: 24px;color: #fff;font-weight: 600;">{{ energy_storage.batEcele_day }}kWh</span>
                                <span style="font-size: 14px;color: #fff;">{{ $t('cumulative.storageConsumption') }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <img src="../../assets/GroupNum.png" style="width: 38px;height: 38px;margin-top: 5px;"
                                alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>




    </div>
</template>

<script>

export default {
    data() {
        return {

        };
    },
    props: {
        energy_storage: {
            default: {}
        },
    },
    watch: {

    },

    methods: {


    }

}
</script>

<style scoped>
.dvBgiBox {
    width: 100%;
    padding: 5px 10px 10px 10px;
    background-image: url("../../assets/dvBgiBoxRight.png");
    background-size: 100% 100%;
    margin-bottom: 20px;
}

.bottomBox {
    position: relative;
    margin-bottom: 20px;
}

.row01 {
    display: flex;
    align-items: center;
    margin-top: 30px;

}

.item {
    width: 76px;
    height: 76px;
    background-image: url("../../assets/right01-1.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    z-index: 2;
}

.item img {
    margin-top: 10px;
}

.tt {
    position: relative;
    width: 120px;
    height: 50px;
}

.tt .imgLeft {
    width: 100%;
    height: 30px;
    position: absolute;
    top: 15px;
    left: -30px;
}

.tt .imgRight {
    width: 100%;
    height: 30px;
    position: absolute;
    top: 15px;
    right: -30px;
}

.right01-7 {
    border-radius: 50%;
    width: 130px;
    height: 130px;
    background-image: url("../../assets/right01-7.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
}
.right01-7:hover {
    transform: scale(1.2);
    box-shadow: 0 0 15px rgba(59, 130, 246, 0.6);
}
</style>